
<v-app class="pro-theme">
  <v-navigation-drawer app color="dark" dark mini fixed style=" overflow: visible!important;transform:translateX(0%);"
    class="pb-6" :mini-variant="drawer" :permanent="!drawer" v-if="false" width="300">

    <!-- Logo img header -->
    <v-list-item class="px-3 mt-6">
      <v-list-item-avatar size="35">
        <v-img alt="Logo" cover src="/icons/large-icon.png" />
      </v-list-item-avatar>
    </v-list-item>
    <v-list>
      <v-list-item-group>
        <v-list-item v-for="(item, i) in items" :to="item.to || ''" :title="item.title" exact
          exact-active-class="primary--text" @click="item.title === 'logout' ? logout() : ''" :key="i" link>
          <v-list-item-icon>
            <v-icon :color="item.title === 'logout' ? 'error' : ''">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t(`menu.${item.title}`) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <!-- Arrow button for activate drawer -->
    <v-card v-if="!drawer">
      <v-card-text class="text-center">
        <!-- progress bar for limit of free plan -->
        <h3 class="mb-3">
          {{ $auth.user?.role ? $auth.user?.role.toUpperCase() : 'Free' }}
          <!-- info buble -->
          <v-tooltip v-if="!$auth.user?.role" bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="primary" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>
              {{ $t('tooltip.free_plan') }}
            </span>
          </v-tooltip>
        </h3>
        <v-progress-linear :value="user.projects.length * 100 / nbOfProjectsBasedOnPlan" color="primary" height="15">
        </v-progress-linear>

        <span class="white--text ">
          {{ user.projects.length }}/{{ nbOfProjectsBasedOnPlan }} {{ $t('label.projects_created') }}
        </span>
        <v-btn elevation="0" v-if="!$auth.user?.role && !isMobile" block class="mt-3" dense primary to="/plan">
          <span class="mr-2">
            <v-icon color="primary">
              mdi-account
            </v-icon>
          </span>
          <span>{{ $t('button.upgrade_to_basic') }}</span>
        </v-btn>

      </v-card-text>
    </v-card>
  </v-navigation-drawer>

  <v-main class="main-with-bottom-nav">
    <!-- Promo Banner after 10 sessions -->
    <div v-if="showPromoBanner && !isPro" class="promo-banner">
      <div class="promo-spacer"></div>
      <div class="promo-content">
        <v-icon color="white" size="18" class="mr-2">mdi-gift</v-icon>
        <span class="promo-text">Offre speciale : <strong>-20%</strong> sur l'abonnement Pro avec le code</span>
        <span class="promo-code" @click="copyPromoCode">BONUS20</span>
        <v-icon v-if="promoCopied" color="white" size="14" class="ml-1">mdi-check</v-icon>
      </div>
      <v-btn icon x-small dark class="promo-close" @click="dismissPromoBanner">
        <v-icon size="16">mdi-close</v-icon>
      </v-btn>
    </div>
    
    <!-- Free Tier Banner -->
    <FreeTierBanner type="general" :dismissible="true" />
    
    <!-- Social Proof Notifications -->
    <SocialProofBanner />

    <template>
      <v-dialog v-model="choiceRegion" max-width="500">
        <ChangeRegion @close="choiceRegion = false" />
      </v-dialog>
    </template>
    <!-- Alert moderne compacte et flottante pour dépassement de plan (caché sur iOS Capacitor) -->
    <div v-if="user.projects.length >= nbOfProjectsBasedOnPlan && !dismissAlert && !isMobile" class="modern-limit-alert-floating">
      <div class="alert-container-compact">
        <!-- Countdown timer -->
        <div class="alert-timer" :style="{ width: `${(autoCloseTimer / 10) * 100}%` }"></div>
        
        <!-- Contenu compact -->
        <div class="alert-content-compact">
          <div class="alert-icon-compact">
            <v-icon color="#ff6b35" size="18">mdi-alert-circle</v-icon>
          </div>
          
          <div class="alert-text-compact">
            <div class="alert-title-compact">{{ $t('message.limit_reached_alert') }}</div>
            <div class="alert-subtitle-compact">{{ user.projects.length }}/{{ nbOfProjectsBasedOnPlan }} {{ $t('label.projects_created') }}</div>
          </div>
          
          <div class="alert-actions-compact">
            <v-btn 
              x-small
              class="upgrade-compact-btn"
              elevation="0"
              @click="$router.push('/plan')"
            >
              <v-icon left size="12">mdi-rocket-launch</v-icon>
              PRO
            </v-btn>
            
            <v-btn 
              icon 
              x-small 
              class="close-compact-btn"
              :class="{ 'close-compact-btn--disabled': autoCloseTimer > 0 }"
              :disabled="autoCloseTimer > 0"
              @click="dismissAlert = true"
            >
              <v-icon size="12" v-if="autoCloseTimer > 0">{{ autoCloseTimer }}</v-icon>
              <v-icon size="12" v-else>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        
        <!-- Particules compactes -->
        <div class="alert-effects-compact">
          <div class="alert-particle-compact" v-for="i in 4" :key="i" :style="getAlertParticleStyle(i)"></div>
        </div>
      </div>
    </div>

    <v-container fluid class="pa-0 ma-0">
      <!-- Transition ultra-fluide pour les changements de page -->
      <transition 
        name="page-slide" 
        mode="out-in" 
        :duration="{ enter: 300, leave: 300 }"
        @before-enter="onBeforeEnter"
        @enter="onEnter"
        @leave="onLeave"
      >
        <router-view :key="$route.fullPath" />
      </transition>
    </v-container>

    <!-- Navigation Bottom Moderne -->
    <div v-if="!cinemaMode && $route.path != '/project'" class="modern-bottom-nav">
      <div class="nav-container">
        
        <!-- Navigation principale -->
        <div class="nav-main-items">
          <div 
            v-for="(item, i) in items" 
            :key="i" 
            class="nav-item"
            :class="{ 'nav-item--active': isActiveRoute(item.to) }"
            @click="navigateToRoute(item)"
          >
            <div class="nav-item-content">
              <div class="nav-icon-wrapper">
                <v-icon 
                  :color="isActiveRoute(item.to) ? 'primary' : 'white'" 
                  :size="isActiveRoute(item.to) ? '24' : '20'"
                  class="nav-icon"
                >
                  {{ item.icon }}
                </v-icon>
                <div v-if="isActiveRoute(item.to)" class="nav-active-indicator"></div>
              </div>
              <span 
                class="nav-label" 
                :class="{ 'nav-label--active': isActiveRoute(item.to) }"
              >
                {{ $t(`menu.${item.title}`) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Bouton Pro flottant (caché sur iOS Capacitor car app payante) -->
        <div v-if="!isPro && !isMobile" class="nav-pro-section" style="z-index:1000!important;">
          <div class="pro-floating-btn" @click="$router.push('/plan')">
            <div class="pro-btn-content">
              <v-icon color="white" size="16" class="mr-1">mdi-star</v-icon>
              <span class="pro-text">PRO</span>
            </div>
            <div class="pro-shine-effect"></div>
          </div>
        </div>
      </div>

      <!-- Indicateur de progression pour utilisateurs gratuits -->
      <div v-if="!isPro && false" class="nav-progress-section">
        <div class="progress-container">
          <div class="progress-info">
            <span class="progress-label">Projets utilisés</span>
            <span class="progress-count">{{ user.projects.length }}/{{ nbOfProjectsBasedOnPlan }}</span>
          </div>
          <div class="progress-bar-container">
            <div 
              class="progress-bar-fill" 
              :style="{ width: `${Math.min((user.projects.length / nbOfProjectsBasedOnPlan) * 100, 100)}%` }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </v-main>
  <!-- IApp désactivé car l'app iOS est payante, pas besoin d'in-app purchase -->
  <IApp v-if="false && iap && isMobile" />
  <v-dialog v-model="popupPlan" max-width="" class="pa-0 ma-0">
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn icon @click="popupPlan = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <PlanView @continue-free="popupPlan = false" />
    </v-card>
  </v-dialog>
</v-app>
